import { Link } from 'react-router-dom';
import './Playlist.css';
import './Policy.css';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

export default function Policy() {
    useEffect(() => {
        // Scroll to the top of the page when the component mounts
        window.scrollTo(0, 0);
    }, []);


    const currentDate = new Date().getFullYear();
    return (
        <div className="privacy-container">
            <Helmet>
                <title>Policy Page</title>
                <meta name="description" content="Policy and privacy policy for Aethel Music" />
            </Helmet>
            <h1 className="privacy-heading">Policy</h1>
            <p>Last Updated: {currentDate}</p>
            <h2 className="policy-text-heading" >Things You Need to Know</h2>

            <p className="policy-text" >
                Æthel focuses on giving our customers a personalized, boutique experience from the world of songwriting. Our songs are crafted to express your stories with integrity and care and craftmanship. All recording projects are available with 50% payment up front and the remaining 50% upon completion of the Bespoke Custom song recording.<br />
                <br /> All songs are for the use of the client in any personal capacity. Aethel reserves the right to maintain sole creative ownership, copywriting all creative material of lyrics and melody and to use her creative works as part of her portfolio and any capacity as the sole owner of copyright and publishing rights.</p>
            <p>Thank you for visiting Æthel Music. Your privacy is important to us. This Privacy Policy outlines how we collect, use, and protect your personal information when you use our contact form.</p>
            <h2 className="policy-text-heading">Information We Collect</h2>
            <p>When you use our contact form, we may collect the following information:</p>
            <p>Name
                <br />Email Address
                <br />Message Content</p>
            <h2 className="policy-text-heading">How We Use Your Information</h2>
            <p>I collect this information solely for the purpose of responding to your inquiries and providing customer support. I do not use this information for marketing purposes or share it with third parties without your consent.</p>
            <h2 className="policy-text-heading">Data Protection</h2>
            <p>I take appropriate measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. This includes encryption and secure storage practices.</p>
            <h2 className="policy-text-heading">Your Rights</h2>
            <p>You have the right to access, correct, or delete your personal information. If you would like to exercise any of these rights or have any questions about my privacy practices, please contact me using the information provided below.</p>
            <h2 className="policy-text-heading">Updates to This Policy</h2>
            <p>I may update this Privacy Policy from time to time. Any changes will be reflected on this page, so please review it periodically.</p>
            <h2 className="policy-text-heading">Contact Us</h2>

            <p>If you have any questions or concerns about my Privacy Policy or my handling of your personal information, please contact me at:</p>
            <p>aethelsongs@gmail.com</p>
            <Link to="/about" id='policy'><button id='policy-home-btn'>Back to Home</button></Link>
        </div>
    )

}
